<div class="toggle-item-container" [class.disabled]="disabled">
  <div class="toggle-item-toggle-wrapper">
    @if (disabled) {
      <ion-spinner class="toggle-item-spinner-start" aria-hidden="true"></ion-spinner>
    } @else {
      <ion-toggle
        [checked]="checked"
        [disabled]="disabled"
        (ionChange)="onToggleChange($event)"
        class="toggle-item-toggle"
      ></ion-toggle>
    }
  </div>
  <ion-label class="toggle-item-label">
    <ng-content></ng-content>
  </ion-label>
  @if (showMenu) {
    @if (!disabled) {
      <ion-button fill="clear" size="small" [id]="menuId" class="toggle-item-menu-button">
        <ion-icon name="ellipsis-vertical" slot="icon-only"></ion-icon>
      </ion-button>
      <ion-popover [trigger]="menuId" [dismissOnSelect]="true">
        <ng-template>
          <crowdctrl-list lines="none">
            <ion-item button lines="none" (click)="onEditClick()">
              <ion-icon name="create-outline" slot="start"></ion-icon>
              <ion-label>Edit</ion-label>
            </ion-item>
            @for (item of extraMenuItems; track item.id) {
              <ion-item button lines="none" (click)="onExtraActionClick(item.id)">
                @if (item.icon) {
                  <ion-icon [name]="item.icon" slot="start"></ion-icon>
                }
                <ion-label>{{ item.label }}</ion-label>
              </ion-item>
            }
          </crowdctrl-list>
        </ng-template>
      </ion-popover>
    } @else {
      <div class="toggle-item-menu-placeholder" aria-hidden="true"></div>
    }
  }
</div>
